<a href="#" style="display: none"></a>

<div class="modal-header">
    <h4 class="modal-title">{{'bcContestEvents_title' | translate}}</h4>
</div>

<div class="modal-body">
    <ng-container *ngIf="!isMultiAddress && events.length && view == 'calendar'">
        <div class="data-value">
            <label>{{'bcContestEvents_lblLocation' | translate}}</label>
            <div>{{events[0].Address}}</div>
        </div>

        <div class="data-value">
            <label>{{'bcContestEvents_lblTime' | translate}}</label>
            <div>
                <div *ngFor="let e of events; let i = index">
                    <ng-container *ngIf="e.DateTime">
                        {{e.Date | date:'EEEE' | titlecase }}, {{e.Date | appDate}}, {{e.TimeFrom | slice: 0 : 5}} - {{e.TimeTo | slice: 0 : 5}}
                    </ng-container>
                </div>
            </div>
        </div>
    </ng-container>

    <table class="table" *ngIf="isMultiAddress && events.length && view == 'calendar'">
        <thead>
            <tr>
                <th>{{'bcContestEvents_lblTime' | translate}}</th>
                <th>{{'bcContestEvents_lblLocation' | translate}}</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let e of events; let i = index">
                <td>
                    <ng-container *ngIf="e.DateTime">
                        {{e.Date | date:'EEEE' | titlecase }}, {{e.Date | appDate}}, {{e.TimeFrom}} - {{e.TimeTo | slice: 0 : 5}}
                    </ng-container>
                </td>
                <td>{{e.Address}}</td>
            </tr>
        </tbody>
    </table>

    <div *ngIf="info">{{info}}</div>
</div>

<div class="modal-footer">
    <button class="btn btn-outline-secondary" (click)="close()" type="button">{{'dialog_close' | translate}}</button>
</div>
